export const SOLD_OUT_TITLE = 'SOLD OUT';
export const SALE_TITLE = 'SALE!';
export const LAST_CHANCE_TITLE = 'LAST CHANCE';
export const NEW_TITLE = 'NEW';
export const BEST_SELLER_TITLE = 'BEST SELLER';
export const GIFT_TITLE = 'FREEBIE';
